// @ts-nocheck
import { createGlobalStyle } from 'styled-components/macro'

export const GlobalStyle = createGlobalStyle`
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Inter', Helvetica, Arial, sans-serif;
  font-display: optional;
  background-color: ${({ theme }) => theme.backgroundColor};
  color: ${({ theme }) => theme.textColor};
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

svg {
  margin: 0 auto;
  display: block;
}

input {
  color: ${({ theme }) => theme.textColor};
  font-size: 14px;
}

::placeholder {
  color: ${({ theme }) => theme.placeholderColor};
  font-size: 14px;
}

*:focus {
  outline: none;
}

a {
  color: ${({ theme }) => theme.textColor};
  text-decoration: none;
  opacity: 1;
  transition: opacity 0.15s ease-in-out-out;
  will-change: opacity;
}

a:hover {
  opacity: 0.9;
}

p {
    font-family: "Inter", sans-serif;
    display: block;
    margin-block-start: 10px;
    margin-block-end: 10px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    color: ${({ theme }) => theme.subTextColor};
}
`
